import React from "react";
import { useTranslation } from "react-i18next";
import { useFormat } from "../../../../i18n/format";
import "./ProfileModal.css";
import ThemeToggle from "../../../UI/ThemeToggle/ThemeToggle";
import RiseModal from "../../../RiseModal/RiseModal";
import { Link } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import {
  IoLogOutOutline,
  IoSettings,
  IoPeople,
  IoPhonePortraitOutline,
} from "react-icons/io5";
import { IoPersonCircle } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useLogout } from "../../../../hooks/useLogout";

// The HAJEX Bolt Warehouse phone app's download page for this server. Not
// set: no link (the server has no app to download yet).
const APP_DOWNLOAD_URL = process.env.REACT_APP_APP_DOWNLOAD_URL;

const AdminProfileModal = ({ onClose, style }) => {
  const user = useSelector((state) => state.user);
  const { t } = useTranslation(["nav", "common"]);
  const { formatMoney } = useFormat();
  const { logout: handleLogout, loggingOut } = useLogout();

  return (
    <RiseModal style={style} onClose={onClose}>
      <div className="profile_modal">
        <div className="profile_modal_title">
          {t("nav:balance", { amount: formatMoney(user.balance) })}
        </div>
        <Link className="profile_modal_item" to="/warehouse-user-profile">
          <IoPersonCircle size={20} className="profile_modal_icon" />
          <div>{t("nav:profile")}</div>
        </Link>
        <Link
          className="profile_modal_item"
          to={"warehouse/settings/table-pagination"}
        >
          <IoSettings size={20} className="profile_modal_icon" />
          <div>{t("nav:settings")}</div>
        </Link>
        {!user?.parent_id && (
          <Link
            className="profile_modal_item"
            to="/warehouse/settings/manage-helper-users"
          >
            <IoPeople size={20} className="profile_modal_icon" />
            <div>{t("nav:users")}</div>
          </Link>
        )}
        {APP_DOWNLOAD_URL && (
          <a
            className="profile_modal_item"
            href={APP_DOWNLOAD_URL}
            target="_blank"
            rel="noreferrer"
          >
            <IoPhonePortraitOutline size={20} className="profile_modal_icon" />
            <div>Get the phone app</div>
          </a>
        )}
        {/* <hr />
        <Link className="profile_modal_item" to="#">
          <MdOutlineGTranslate size={20} className="profile_modal_icon" />
          <div>Language222</div>
        </Link> */}

        <hr />
        <div className="flex items-center justify-between gap-2 px-[15px] py-[7px] text-[8px] text-ui-text-muted select-none">
          <span>{t("common:theme.label")}</span>
          <ThemeToggle compact />
        </div>
        <hr />
        <div
          className={`profile_modal_item ${
            loggingOut && "profile_modal_itemdisabled"
          }`}
          onClick={handleLogout}
        >
          <IoLogOutOutline size={20} className="profile_modal_icon" />
          <div>{t("common:actions.logout")}</div>
          {!loggingOut && (
            <div className="version__badge">
              {process.env.React_APP_Version}
              <span></span>
            </div>
          )}
          <span className="pm_item_logoutloader">
            {" "}
            {loggingOut && <CircularProgress size={16} />}
          </span>
        </div>
      </div>
    </RiseModal>
  );
};

export default AdminProfileModal;
